export default class subscriberActivity {
    constructor() {
        return {
            scope: {
                subscriber: "="
            },
            template: require('../../../../views/subscriber/show/subscriber-activity.html'),
            controller: [
                '$scope', '$element', '$attrs', '$stateParams', '$filter', '$timeout', 'Events', 'SweetAlert', 'Subscriber',
                (scope, element, attr, $stateParams, $filter, $timeout, Events, SweetAlert, Subscriber) => {

                var page = 1;
                scope.activities = [];

                var parseResponse = (response) => {
                    _.each(response.data, (item) => {
                        item.name = item.dispatcher_type.id === 1 ? item.campaign_name : item.transactional_name;
                        scope.activities.push(item);
                    });

                    scope.pages = response.meta.pagination.total_pages;
                };

                var setPageActivity = (page) => {
                    Subscriber.activity($stateParams.id, page).then((result) => {
                        parseResponse(result);

                        if (page >= result.meta.pagination.total_pages) { // Add a creation activity.
                            $timeout(() => {
                                scope.activities.push({
                                    created_at: scope.subscriber.created_at,
                                    type: 'SubscriberCreation'
                                });
                            }, 500);
                        }
                    });
                };

                setPageActivity(1);

                scope.nextPage = () => {
                    if (page >= scope.pages) {
                        return Events.flashEvent('error', 'Subscriber has no more activities');
                    }

                    page++;
                    setPageActivity(page);
                };

                var searchTimeout;

                scope.searchActivities = () => {
                    if (searchTimeout) {
                        $timeout.cancel(searchTimeout);
                    }

                    searchTimeout = $timeout(() => {
                        Subscriber.activity($stateParams.id, page, scope.search).then((results) => {
                            scope.activities = [];
                            parseResponse(results);
                        });
                    }, 500);
                };

                scope.clearSearch = () => {
                    scope.search = "";
                    scope.activities = [];

                    setPageActivity(1);
                };
            }]
        };
    }
}